export default "__VITE_ASSET__DRdYB5X1__"